import { OnDestroy, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';


@Injectable()
export class TranstationFactory implements  OnDestroy {
    private factory: Object;

    constructor(
        private translate: TranslateService
    ) {
        this.load();
    }
    ngOnDestroy(): void {
        this.factory = null;
    }

    load(): void {
        this.translate.getTranslation(this.translate.currentLang != undefined ? this.translate.currentLang: 'en').subscribe((res: Object) => {
            this.factory = res;
        });
    }

    set(object: Object): void {
         this.factory = object;
    }

    get(key: string): string {
        return this.factory[key];
    }

}
